import React, { FC, useEffect, useState } from 'react'
import { Input } from '@wmgtech/legato'

import styles from './SearchUser.module.scss'
import { SearchUserProps } from './SearchUser.props'

const SearchUser: FC<SearchUserProps> = ({ handleSearchUser, loading }) => {
  const [value, setValue] = useState<string>('')

  useEffect(() => {
    handleSearchUser(value)
  }, [handleSearchUser, value])

  return (
    <Input
      className={styles.input}
      placeholder="Search for Users"
      onChange={({ target: { value } }) => setValue(value)}
      value={value}
      isClearable
      crossOrigin
      containerStyle="outline"
      validation={{
        pending: loading
      }}
      suffixIcon="magnifying-glass"
    />
  )
}

export default SearchUser
